import gql from "graphql-tag";

export const ApproveMonitoring = gql`
  mutation ApproveMonitoring ($id: String!) {
    approveMonitoring(id: $id)
  }
`;
